import React from "react";
import { TRANG_THAI_DIEM_DANH } from "../../constants";

const DiemDanhMobile = ({
  filtered, diemDanh, ghiChu, historyMap, hsFullStats,
  tongBuoiDaDD, searchOpen, searchTerm, searchRef,
  setSearchOpen, setSearchTerm, setTrangThai, setGhiChuHS,
  openHistory, STATUS_STYLE  // ✅ Nhận qua props
}) => {
  return (
    <>
      {/* ===== SEARCH FULL MÀN HÌNH ===== */}
      {searchOpen && (
        <div className="fixed inset-0 z-50 bg-surface flex flex-col">
          <div className="flex items-center gap-2 px-4 py-3 border-b border-outline-variant">
            <button onClick={() => { setSearchOpen(false); setSearchTerm(""); }} className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-surface-container">
              <span className="material-symbols-outlined">arrow_back</span>
            </button>
            <input ref={searchRef} type="text" placeholder="Tìm học sinh..." value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              className="flex-1 bg-transparent border-none outline-none text-body-md" autoFocus />
            {searchTerm && (
              <button onClick={() => setSearchTerm("")} className="w-8 h-8 rounded-full flex items-center justify-center">
                <span className="material-symbols-outlined">close</span>
              </button>
            )}
          </div>
          <div className="flex-1 overflow-y-auto p-4">
            {filtered.length === 0 ? (
              <div className="text-center py-12 text-on-surface-variant">
                <span className="material-symbols-outlined text-[48px]">search_off</span>
                <p className="mt-2">Không tìm thấy học sinh</p>
              </div>
            ) : <p className="text-caption text-on-surface-variant mb-2">{filtered.length} kết quả</p>}
            {filtered.slice(0, 20).map(hs => {
              const tt = diemDanh[hs.id];
              const style = STATUS_STYLE[tt] || STATUS_STYLE['null'];
              return (
                <button key={hs.id} onClick={() => setSearchOpen(false)}
                  className="w-full flex items-center gap-3 p-3 hover:bg-surface-container rounded-lg text-left">
                  <div className="w-9 h-9 rounded-full bg-primary-container text-on-primary-container flex items-center justify-center font-bold text-sm">{hs.hoTen?.charAt(0)}</div>
                  <div className="flex-1 min-w-0"><p className="text-body-md font-semibold truncate">{hs.tenThanh ? `Th. ${hs.tenThanh} - ` : ''}{hs.hoTen}</p></div>
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${style.bg} ${style.text}`}>{style.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* ===== CARD LIST ===== */}
      <div className="space-y-2">
        {filtered.length === 0 && (
          <div className="text-center py-12 text-on-surface-variant">
            <span className="material-symbols-outlined text-[48px]">search_off</span>
            <p className="mt-2">Không tìm thấy học sinh</p>
          </div>
        )}
        {filtered.map(hs => {
          const tt = diemDanh[hs.id];
          const style = STATUS_STYLE[tt] || STATUS_STYLE['null'];
          const dots = historyMap[hs.id] || [];
          const stat = hsFullStats[hs.id];
          return (
            <div key={hs.id} className="bg-surface rounded-xl p-3 shadow-[0px_2px_8px_rgba(0,0,0,0.05)] border border-outline-variant">
              <div className="flex items-center gap-2 mb-2" onClick={() => openHistory(hs)}>
                <div className="w-9 h-9 rounded-full bg-primary-container text-on-primary-container flex items-center justify-center font-bold text-sm flex-shrink-0">{hs.hoTen?.charAt(0)}</div>
                <div className="flex-1 min-w-0">
                  <p className="text-body-md font-semibold truncate">{hs.tenThanh ? `Th. ${hs.tenThanh} - ` : ''}{hs.hoTen}</p>
                  <div className="flex items-center gap-2 mt-0.5">
                    <div className="flex items-center gap-1">
                      {dots.length > 0 ? dots.map((status, i) => {
                        const s = STATUS_STYLE[status] || STATUS_STYLE['null'];
                        return <div key={i} className={`w-2 h-2 rounded-full ${s.dot}`} title={s.label} />;
                      }) : <span className="text-[10px] text-on-surface-variant/50">...</span>}
                    </div>
                    {stat && tongBuoiDaDD > 0 && (
                      <span className={`text-[10px] font-bold ${stat.vangKP > 0 ? 'text-error' : 'text-green-600'}`}>
                        {stat.coMat}/{tongBuoiDaDD} buổi
                        {stat.vangKP > 0 && ` • KP ${stat.vangKP}`}
                      </span>
                    )}
                  </div>
                </div>
                <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${style.bg} ${style.text}`}>{style.label}</span>
              </div>
              <div className="grid grid-cols-4 gap-1">
                {Object.entries(TRANG_THAI_DIEM_DANH).map(([k, v]) => {
                  const s = STATUS_STYLE[k];
                  const isActive = tt === k;
                  return (
                    <button key={k} onClick={() => setTrangThai(hs.id, k)}
                      className={`py-2 rounded-lg flex flex-col items-center gap-0.5 transition-all text-[10px] font-bold
                        ${isActive ? `${s.bg} ${s.text} border-2 ${s.border}` : 'bg-surface-container text-on-surface-variant border border-outline-variant'}`}>
                      <span className="material-symbols-outlined text-[16px]" style={isActive ? { fontVariationSettings: "'FILL' 1" } : {}}>{s.icon}</span>
                      {v.label}
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default DiemDanhMobile;